// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"614":"d244151d79d0a97c","9337":"507ba7ba7cdd5ebb"}[chunkId] + ".css";
};